<script lang="ts" setup>
import { ref, Ref, onMounted } from "vue";

interface Image {
    id: number;
    urlXXL: string;
    urlSmall: string;
    urlLarge: string;
    orientation: string;
    order: number;
}

const props = defineProps<{ images: Image[] }>();

const imageHolder = ref();

let isOpen = ref(false);

let viewingId: Ref<number | false> = ref(false);

const handleOpen = (id: number) => {
    if (!id && props.images) {
        viewingId.value = props.images[0].id;
    } else {
        viewingId.value = id;
    }

    isOpen.value = true;

    disableScrolling(true);

    setTimeout(() => {
        const sliderImage: HTMLElement = imageHolder.value.querySelector(`#silder-image-${viewingId.value}`) as HTMLElement;
        const offset: number = sliderImage?.offsetTop || 0;
        imageHolder.value.scrollTo({ top: offset });
    }, 200);
};

const close = () => {
    isOpen.value = false;
    disableScrolling(false);
};

const disableScrolling = (disable: boolean) => {
    const body: HTMLElement | null = document.querySelector("body");

    if (disable) {
        body!.classList.add("overflow-y-hidden");
    } else {
        body!.classList.remove("overflow-y-hidden");
    }
};
setTimeout(function () {
    document.querySelectorAll(".slider-image").forEach((el) => {
        el.addEventListener("click", (event) => {
            // @ts-ignore
            handleOpen(Number(event.target.dataset.nr));
        });
    });
}, 500);
</script>

<template>
    <div class="flex justify-center">
        <div ref="imageHolder" class="image-holder cursor-pointer" :class="{ open: isOpen }" @click="close()">
            <div class="images cursor-default">
                <img :id="`silder-image-${item.id}`" @click.stop v-for="item in images" :key="item.id" :data-src="item.urlXXL" class="lazyload mb-[24px] lg:mb-[40px] w-100 w-full" />
            </div>
        </div>
        <div :class="{ open: isOpen }" @click="close()" class="close flex items-center bg-white uppercase font-semi text-15 text-dark py-[24px] px-[40px] cursor-pointer duration-300 transition-all transform-gpu hover:scale-110">
            sluiten
            <fa-icon icon="close" class="text-15 text-brown-200 ml-[8px]" />
        </div>
    </div>
</template>

<style scoped>
.image-holder {
    -webkit-backdrop-filter: saturate(180%) blur(15px) opacity(0);
    backdrop-filter: saturate(180%) blur(15px) opacity(0);
    pointer-events: none;
    position: fixed;
    left: 0;
    top: 0;
    transition: backdrop-filter 0.25s ease-in, background 0.25s ease-in;
}
.image-holder.open {
    -webkit-backdrop-filter: saturate(180%) blur(15px) opacity(1);
    backdrop-filter: saturate(180%) blur(15px) opacity(1);
    background: #252526cc;
    pointer-events: all;
    height: 100vh;
    width: 100vw;
    z-index: 1000;
    overflow: auto;
}
.image-holder.open .images {
    top: 40px;
    opacity: 1;
}

@media (min-width: 1024px) {
    .image-holder.open .images {
        top: 80px;
    }
}
.image-holder .images {
    display: flex;
    flex-flow: column;
    margin: 0 auto;
    max-width: calc(100% - 40px);
    height: auto;
    top: 100vh;
    position: absolute;
    left: 0;
    right: 0;
    opacity: 0;
    transition-property: top, opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
}

@media (min-width: 1024px) {
    .image-holder .images {
        max-width: 78.88%;
    }
}
.image-holder img {
    max-height: calc(100vh - 160px);
    object-fit: contain;
}
.close {
    position: fixed;
    bottom: -112px;
    z-index: 1001;
}
.close.open {
    bottom: 40px;
}
</style>
